export const customSolutions = {
  hero: {
    title: 'Soluciones a medida',
    subtitle: 'Estudiamos tu negocio y diseñamos automatizaciones personalizadas que se adaptan perfectamente a tus necesidades'
  },
  intro: {
    title: 'Automatización diseñada para ti',
    description: 'Cada negocio es único. Por eso analizamos tu flujo de trabajo actual y creamos soluciones de automatización que incluyen gestión de agenda, chatbot para WhatsApp y redes sociales, recordatorios automáticos, desarrollo web e integraciones con herramientas como Google Calendar.'
  },
  process: {
    title: 'Nuestro proceso',
    steps: [
      {
        title: 'Diagnóstico',
        description: 'Analizamos tu negocio, identificamos oportunidades de automatización y definimos objetivos claros para maximizar tu eficiencia.'
      },
      {
        title: 'Diseño',
        description: 'Creamos una solución personalizada que integra chatbot, agenda, recordatorios y web, adaptada a tu flujo de trabajo específico.'
      },
      {
        title: 'Implementación y soporte',
        description: 'Configuramos todas las herramientas, te formamos en su uso y te acompañamos con soporte continuo para garantizar resultados.'
      }
    ]
  },
  cta: {
    title: '¿Listo para una solución a tu medida?',
    subtitle: 'Cuéntanos sobre tu negocio y diseñaremos la automatización perfecta para ti'
  }
};
